import React from 'react'
import PropTypes from 'prop-types'

const IconEdit = ({size = 16}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.862 1.529a2.552 2.552 0 1 1 3.61 3.609l-8.805 8.804-.033.034c-.163.163-.307.307-.478.42a2 2 0 0 1-.485.233 3.132 3.132 0 0 1-.628.111l-.046.005-2.257.25a.667.667 0 0 1-.736-.735l.25-2.257c.003-.015.004-.03.006-.046.025-.23.048-.433.11-.628a2 2 0 0 1 .234-.485 3.125 3.125 0 0 1 .454-.511l8.804-8.804Zm2.667.942a1.219 1.219 0 0 0-1.724 0L2 11.276c-.215.215-.255.259-.284.302a.665.665 0 0 0-.078.162c-.016.05-.025.108-.06.41l-.158 1.429 1.428-.159c.302-.034.361-.043.41-.06a.665.665 0 0 0 .163-.077c.043-.029.087-.069.302-.284l8.805-8.804a1.219 1.219 0 0 0 0-1.724Z"
        fill="currentColor"
      />
    </svg>
  )
}

IconEdit.propTypes = {
  size: PropTypes.number,
}

export default IconEdit
